import { RetrieveSignatureSessionResponseBody } from 'bff'
import { useSignature } from '../components/Signing'
import { useQuery } from '@tanstack/react-query'

export const buildSignatureSessionQueryKey = (signatureSessionId: string) =>
  `signature-session-${signatureSessionId}`

export interface UseSignatureSessionQueryProps {
  onResponse?: (response: RetrieveSignatureSessionResponseBody) => Promise<void>
  reactiveQueryEnabled: boolean
}

export const useSignatureSessionQuery = (
  initialSignatureSession: RetrieveSignatureSessionResponseBody,
  opts: UseSignatureSessionQueryProps = {
    reactiveQueryEnabled: true,
  }
) => {
  const { onSignatureReceived, retrieveSignatureSession } = useSignature()

  return useQuery({
    queryFn: () =>
      retrieveSignatureSession().then(async (res) => {
        if (res.status === 'signed' && res.signature) {
          onSignatureReceived(res.signature)
        }

        if (opts.onResponse) {
          await opts.onResponse(res)
        }

        return res
      }),
    queryKey: [buildSignatureSessionQueryKey(initialSignatureSession.id)],
    refetchInterval: opts.reactiveQueryEnabled ? 2000 : false,
    initialData: initialSignatureSession,
  })
}
